import { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import Scorecard from "./scorecard";
import CondoPieChart from "./occupancyPie";
import EditPropertyForm from "../../forms/editPropertyForm"

import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";

const DashboardHeader = ({ userData, propertiesData, unitsData, selectedProperty, onPropertyChange }) => {
    const [images, setImages] = useState([]);
    const [isEditOpen, setIsEditOpen] = useState(false);

    const queryClient = useQueryClient();

    const user = userData.user.userData.givenName;
    const userName = user && user.charAt(0).toUpperCase() + user.slice(1);

    useEffect(() => {
        if (selectedProperty.images && selectedProperty.images.length > 0) {
            setImages(selectedProperty.images);
        }
    }, [selectedProperty]);

    return (
        <div className="welcome-box">
            <div className="welcome-box-info">
                <div className="welcome-box-text">
                    <h1>Welcome back, {userName}!</h1>
                    <p>This is your property portfolio for the month.</p>
                </div>
                <div className="welcome-box-stats">
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <Autocomplete
                            options={propertiesData || []}
                            value={selectedProperty || null}
                            onChange={(e, newVal) => onPropertyChange(newVal)}
                            isOptionEqualToValue={(option, value) => option?._id === value?._id}
                            getOptionLabel={(option) => option?.name || ""}
                            renderInput={params => (
                                <TextField {...params}
                                    variant="outlined"
                                    sx={{
                                        backgroundColor: '#fff',
                                        borderRadius: '9.5px',
                                        mb: 1,
                                        width: '320px',
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '9.5px',
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: '#888',
                                        },
                                    }} />
                            )}
                            sx={{ width: "100%", marginBottom: "5px" }}
                        />
                        <Scorecard data={unitsData} />
                    </div>
                    <CondoPieChart data={unitsData} />
                </div>
            </div>
            <div className="welcome-box-property" style={{ position: "relative" }}>
                {images.length > 0 ? (
                    images.map((photo) => (
                        <img
                            key={photo._id}
                            src={photo.key}
                            alt={photo.altText || "Property Photo"}
                            className="unit-photo"
                        />
                    ))
                ) : null}

                <IconButton
                    aria-label="edit"
                    size="small"
                    sx={{
                        position: "absolute",
                        top: 30,
                        right: 30,
                        backgroundColor: "rgba(255,255,255,0.8)",
                        "&:hover": { backgroundColor: "rgba(255,255,255,1)" },
                        boxShadow: 1
                    }}
                    onClick={() => setIsEditOpen(true)}
                >
                    <EditIcon />
                </IconButton>
            </div>
            {isEditOpen && (
                <EditPropertyForm
                    property={selectedProperty}
                    propertyId={selectedProperty?._id}
                    onClose={() => setIsEditOpen(false)}
                    onPropertyUpdated={(updatedProperty) => {
                        queryClient.invalidateQueries(['v2-properties']);
                        onPropertyChange(updatedProperty);
                        setIsEditOpen(false);
                    }}
                />
            )
            }
        </div >
    );
}

export default DashboardHeader;